import {Pressable} from 'react-native';
import { ThemedPressable, ThemedText, ThemedView, themeTextVariants } from '@app/theme';
import Button from '@app/sharedComponents/Button/Button';
import { ArrowUpRight, Warning,Info,WarningCircle } from '@app/sharedComponents/Icons/Icons';
import { formatIndianCurrency } from '@app/utils/utility';
import dayjs from 'dayjs';
import ROUTE from '@app/navigationApp/routes';
import { useAppSelector } from '@app/store/hooks';


const InterestDueCard = ({bankDetails,interestDetails,isFromTata,navigation}) => {
  const {totalAmount,interestStatus,autoPayDate,isMandateSetup,month,year,sellOffDate} = interestDetails
  //  assuming hardbreach date to be 10th of every month, but shall be provided by api
  const  hardBreachDate = sellOffDate?new Date(sellOffDate).getDate():  15//
  const {accountNumber,bankName,bankCode} = bankDetails || {};
  const firebaseParams = useAppSelector((state) => state.firebaseParams);
  const interestMsg = ()=>{
    const currentDate = firebaseParams?.follow_firebase_date==="true" ? dayjs(firebaseParams?.current_volt_date): dayjs()
    const currentMonth = currentDate.format('MMM'); // get current month name like Jan or feb etc
    const currentYear = currentDate.format('YY'); // get current year like 25 or 24 etc
    const softBreachDate = new Date(autoPayDate).getDate(); // autodebit date is assumed to be soft breach date
    const isHardDateBreached = Number(currentDate.format('DD')) >= hardBreachDate;
    if(interestStatus === "DUE"){
      if(isMandateSetup){
        // msg Auto-debit on {softBreachDate} {currentMonth}, {currentYear} from HDFC XXXX 7029
        return (
        <ThemedText variant='b4r' color='text-primary' ml="sm">
          Auto-debit on <ThemedText variant='b4b' color='text-primary'>{softBreachDate}-{currentMonth}</ThemedText>
          , Ensure balance of 
          <ThemedText variant='b4b' color='text-primary'> ₹{formatIndianCurrency(totalAmount)} </ThemedText>
            in {bankName} {accountNumber?.toString().slice(-4)}</ThemedText>
      )
      }else{
        // msg Pay by {softBreachDate}-{currentMonth} to avoid penalty charges
        return(
        <ThemedView flexDirection='row' alignItems='center' ml="sm" flex={1} flexWrap='wrap'>
          <ThemedText variant='b4r' color='text-primary'>
            Pay by{' '}   
            <ThemedText variant='b4b' color='text-primary'>
              {softBreachDate}-{currentMonth} 
            </ThemedText>
          {' '}to avoid penalty charges
          </ThemedText>
        </ThemedView>
        )

      }
    } else if(interestStatus === "AWAITING_MANDATE_STATUS" && isMandateSetup){
      // msg Processing auto-debit! Need help? Learn more
      return (
        <ThemedView flexDirection='row' alignItems='center' flex={1} flexWrap='wrap'  ml="sm">
        <ThemedText variant='b4b' color='text-primary'>We are processing auto-debit.
          <ThemedText variant='b4r' color='text-primary'> It may take up to 2 business days. Need help? </ThemedText>
          <ThemedPressable  ml="2xs" onPress={()=>navigation.navigate(ROUTE.CONTACT_US)}>
            <ThemedText variant='b4b' color='text-action-primary'>
            Contact us
            </ThemedText>
          </ThemedPressable>
        </ThemedText>
        </ThemedView>
      )
    } else if(interestStatus === "OVERDUE"){
      // msg Last auto-debit failed! Pay before {hardBreachDate} {currentMonth}, {currentYear} to avoid defaulting.
      if(isHardDateBreached){
       return(  <ThemedView flexDirection='row' alignItems='center' flex={1} flexWrap='wrap' ml="sm">
        <ThemedText variant='b4r' color='text-primary'>Your interest is still overdue. Need help?</ThemedText>
        <ThemedPressable onPress={()=>navigation.navigate(ROUTE.CONTACT_US)} eventName="CONTACT_US_BUTTON">
          <ThemedText variant='b4b' color='text-action-primary'>
            {' '}Contact support
          </ThemedText>
        </ThemedPressable>
        </ThemedView>)
      }
      else if(isMandateSetup){
        return(
        <ThemedView flexDirection='row' alignItems='center' flex={1} flexWrap='wrap' ml="sm">
          <ThemedText variant='b4b' color='text-primary'>Last auto-debit failed! </ThemedText>
          <ThemedText variant='b4r' color='text-primary'>Pay by<ThemedText variant='b4b' color='text-primary'> {hardBreachDate}-{currentMonth}</ThemedText> to avoid defaulting.</ThemedText>
          <ThemedPressable ml="2xs" onPress={()=>navigation.navigate(ROUTE.INTEREST_LEARN_MORE,{outstandingInterest:totalAmount,isFromTata})}>
            <ThemedText variant='b4b' color='text-action-primary'>
              Learn more
            </ThemedText>
          </ThemedPressable>
        </ThemedView>
        )
      }
      else if(!isMandateSetup && !isHardDateBreached){
        return(
        <ThemedView flexDirection='row' alignItems='center' flex={1} flexWrap='wrap' ml="sm">
          <ThemedText variant='b4r' color='text-primary'>Pay by <ThemedText variant='b4b' color='text-primary'>{hardBreachDate}-{currentMonth}</ThemedText> to avoid defaulting.</ThemedText>
          <ThemedPressable ml="2xs" onPress={()=>navigation.navigate(ROUTE.INTEREST_LEARN_MORE,{outstandingInterest:totalAmount,isFromTata})}>
            <ThemedText variant='b4b' color='text-action-primary'>
              Learn more
            </ThemedText>
          </ThemedPressable>
        </ThemedView>
        )
      } else{
        // msg Your interest is still overdue. Need help? Contact support
        return(
        <ThemedView flexDirection='row' alignItems='center' flex={1} flexWrap='wrap' ml="sm">
        <ThemedText variant='b4r' color='text-primary'>Your interest is still overdue. Need help?</ThemedText>
        <ThemedPressable onPress={()=>navigation.navigate(ROUTE.CONTACT_US)} eventName="CONTACT_US_BUTTON" >
          <ThemedText variant='b4b' color='text-action-primary'>
            Contact support
          </ThemedText>
        </ThemedPressable>
        </ThemedView>
        )
      }
    } else{
      return null
    }
  }

  const viewDetails = ()=>{
    navigation.navigate(ROUTE.INTEREST_PAYMENT)
  }
    return(
      <ThemedView mx='lg' mt='2xl'>
        <ThemedText variant='b3s' color='text-primary' mb="sm">{interestStatus === "OVERDUE" ? 'Your account is overdue!':`${month}'${year?.slice(-2)} statement has been generated`}</ThemedText>
        <ThemedView  borderColor='border-primary' backgroundColor='bg-surface-primary' borderWidth={1} borderRadius='lg' style={[]} >
        <ThemedView p='lg' flexDirection='row' justifyContent='space-between'>
          <ThemedView>
            <ThemedText color='text-secondary'  variant='b4r' pb='2xs' >
              Amount {interestStatus==="OVERDUE" ? 'overdue' : 'due'}
            </ThemedText>
            <ThemedText color='text-primary'  variant='b3s'>
              ₹{formatIndianCurrency(totalAmount)}
            </ThemedText>
          </ThemedView>
          <ThemedView>
            <Button type={interestStatus === "OVERDUE" || !isMandateSetup? 'SOLID':'OUTLINED'} label={interestStatus === "OVERDUE" || !isMandateSetup?'Pay now':'View details'} size='SM' overRideStyle={{paddingHorizontal:10}} handlePress={viewDetails} />
          </ThemedView>
        </ThemedView>
        <ThemedView flexDirection='row'  backgroundColor={interestStatus === "OVERDUE" ?'bg-fill-error' :'bg-fill-warning'} px='lg' py='sm' borderBottomRightRadius='lg' borderBottomLeftRadius='lg' borderTopColor='border-primary' borderTopWidth={1} >
          {interestStatus === "OVERDUE"? <Info size={20} weight="fill" color='#de4044'/>:<Info size={20} weight="fill"  color="#f9bd21"/>}
          {interestMsg()}
        </ThemedView>
      </ThemedView>
      </ThemedView>
    )
}

export default InterestDueCard;